/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import 'sal.js/dist/sal.css';
import sal from 'sal.js';
import { render } from 'storyblok-rich-text-react-renderer';

import FluidImage from 'components/fluidImage';
import Toggle from 'components/shared/toggle/toggle';

const ColumnImageBlock = ({ blok }) => {
  useEffect(() => {
    if (blok.animate) {
      sal({ threshold: 0.25 });
    }
  }, [blok.animate]);

  const isAnimate = blok.animate;

  return (
    <div className="container">
      <div
        className={`grid gap-4 py-7 lg:gap-8 lg:py-8 xl:gap-10 xl:py-10 ${
          (blok.image_right?.filename == null && blok.image_left?.filename !== null) ||
          (blok.image_left?.filename == null && blok.image_right?.filename !== null)
            ? 'grid-cols-none lg:grid-cols-2'
            : ' grid-cols-2'
        }`}
      >
        {blok.image_left && (
          <div
            className={`lg:aspect-auto ${blok.toggle_blocks ? 'lg:row-span-3' : ''}
            `}
            {...(isAnimate
              ? {
                  'data-sal': 'slide-up',
                  'data-sal-duration': '1000',
                  'data-sal-delay': '0',
                  'data-sal-easing': 'ease',
                }
              : {})}
          >
            <FluidImage
              image={blok.image_left}
              className={`${blok.toggle_blocks ? 'w-full' : 'h-full w-full'}`}
              critical={false}
            />
          </div>
        )}
        {blok.image_right && blok.image_right?.filename && (
          <div
            className="lg:ml-[15%] lg:max-w-[85%] xl:ml-[25%] xl:max-w-[75%]"
            {...(isAnimate
              ? {
                  'data-sal': 'slide-up',
                  'data-sal-duration': '1000',
                  'data-sal-delay': '0',
                  'data-sal-easing': 'ease',
                }
              : {})}
          >
            <FluidImage image={blok.image_right} className="w-full" critical={false} />
          </div>
        )}
        {blok.toggle_blocks && blok.toggle_blocks.length > 0 && (
          <div className="col-span-2 mt-10 lg:col-span-1 lg:ml-[15%] lg:mt-4 lg:max-w-[85%] xl:ml-[25%] xl:mt-10 xl:max-w-[75%]">
            {blok.toggle_blocks.map((block) => {
              const { title, content_blocks } = block;
              return (
                <div key={block._uid} className="mobile:grid mobile:grid-cols-2 mobile:gap-4">
                  <Toggle
                    text={title}
                    className="mb-5 lg:mb-8 xl:mb-10"
                    id={block._uid}
                    isAccordion
                  >
                    <div className="prose mb-12 space-y-5 text-sm !leading-[1.12] lg:text-lg xl:mb-20 xl:space-y-10 xl:text-2xl">
                      {content_blocks.map((content) => {
                        const { text_left, text_right } = content;
                        return (
                          <div className="flex gap-4" key={content._uid}>
                            <div className="w-1/2 flex-[0_0_40%] font-semibold lg:flex-[0_0_35%] xl:flex-[0_0_25%]">
                              {text_left}
                            </div>
                            <div className="prose w-1/2 flex-1 text-sm !leading-[1.12] lg:text-lg xl:text-2xl">
                              {render(text_right)}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </Toggle>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ColumnImageBlock;

ColumnImageBlock.propTypes = {
  blok: PropTypes.object.isRequired,
};
